import { Story } from '../../DocTypes';

export const dataDrivenButtonStylesStory: Story = {
  title: 'Data driven button styles',
  description: 'List with items having buttons that are styled by data',
  coreComponent: {
    html: `<tag-list
    primary-field='name'
    secondary-field='description'
    button-1-icon='Edit'
    button-1-rounded
    button-1-style-field='style'>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      {
        name: 'Jordan Norry',
        disableEdit: true,
        description: 'Button should be hidden',
        style: '{"display": "none"}'
      },
      {
        name: 'Sarah Young',
        disableEdit: false,
        description: 'Button should be shown',
        style: '{"display": "block"}'
      },
      {
        name: 'Susan Warmly',
        disableEdit: true,
        description: 'Button should be hidden',
        style: '{"display": "none"}'
      }
    ]);
  });
  `,
  },
  reactWrapper: {
    jsx: `<TagList
    primaryField='name'
    secondaryField='description'
    button1Icon='Edit'
    button1Rounded
    button1StyleField='style'
    data={[
      {
        name: 'Jordan Norry',
        disableEdit: true,
        description: 'Button should be hidden',
        style: '{"display": "none"}'
      },
      {
        name: 'Sarah Young',
        disableEdit: false,
        description: 'Button should be shown',
        style: '{"display": "block"}'
      },
      {
        name: 'Susan Warmly',
        disableEdit: true,
        description: 'Button should be hidden',
        style: '{"display": "none"}'
      }
    ]}
  />`,
  },
};
